import React, { Component } from 'react';
import apiConfig from '../../api/apiConfig'
import './style.css';

import {Link} from 'react-router-dom';
import Icon from 'react-icons-kit';
import {androidDelete} from 'react-icons-kit/ionicons/androidDelete';
import {edit} from 'react-icons-kit/ionicons/edit';

class EditDemoCategories extends Component {
  constructor(props){
    super(props)

    this.state={
      file: '',
      quesListArray : [],
      categoryID : "",
      order_no :"",
      categoryName:"",
      catID:"",
      catImage : "",
      validationMsg: {},
      hideCategoryEdit : true,
      catActionButton : "Edit"
    }

    this.onChange = this.onChange.bind(this);
    this.saveData = this.saveData.bind(this);
    this.addQuestion = this.addQuestion.bind(this);
    this._handleImageChange = this._handleImageChange.bind(this);
  }

  componentWillMount(){
    if(this.props.editCategoryItem){
      this.setState({
        categoryID : this.props.editCategoryItem._id,
        catID : this.props.editCategoryItem.cat_id,
        categoryName : this.props.editCategoryItem.catName,
        order_no : this.props.editCategoryItem.order_no+ "",
        catImage : this.props.editCategoryItem.image_url,
      });
    }

    if(this.props.demoGraphicsCategoriesQuesListSuccess && this.props.demoGraphicsCategoriesQuesListData){
      this.setState({
        quesListArray : this.props.demoGraphicsCategoriesQuesListData,
      });
    }
  }

  componentWillReceiveProps(nextProps){
     
    if(nextProps.demoGraphicsCategoriesUpdateSuccess && nextProps.demoGraphicsCategoriesUpdateSuccessMessage){
      alert(nextProps.demoGraphicsCategoriesUpdateSuccessMessage);
      this.props.emptyDemographicsCategories();
    }else if(nextProps.demoGraphicsCategoriesUpdateFailMessage){
      alert(nextProps.demoGraphicsCategoriesUpdateFailMessage);
      this.props.emptyDemographicsCategories();
    }
  }

  onChange(e){
  this.setState({[e.target.name]: e.target.value});
  }

  handleValidation() {
		let valid = true;
    let error = {};

		if (this.state.categoryName === "") {
      error.categoryName = "Can't leave empty";
			valid = false;
    }
    if (this.state.order_no === "") {
      error.order_no = "Please enter order_no";
      valid = false;
		}else if (!(this.state.order_no).match(/^\d*$/)){
      error.order_no = "Please only enter numeric characters in order_no";
      valid = false;
    }
    if( !this.state.file && !this.state.catImage){
      error.file = "Please choose image";
      valid = false;
    }
    this.setState({ validationMsg: error });
		return valid;
  }
  
  _handleImageChange(e) {
    let reader = new FileReader();
    let file1 = e.target.files[0];

    this.setState({
      file: file1,
      value: e.target.value,
    });
  }

  saveData(){

    if(this.state.hideCategoryEdit){
      this.setState({ hideCategoryEdit : false, catActionButton : 'Update'});
    }else{
     
      if (this.handleValidation()) {

        const catData = new FormData();
        catData.append('category_id', this.state.categoryID);
        catData.append('sampleFile', this.state.file);
        catData.append('categoryName', this.state.categoryName);
        catData.append('order_no', this.state.order_no);

        // catData.category_id = this.state.categoryID;
        // catData.catID = this.state.catID;
        // catData.categoryName = this.state.categoryName;
        // catData.order_no = this.state.order_no;     
         this.props.updateDemoCategory(catData);    
      }
    }   
  }

  categoryList(){
    this.props.categoryList();
  }

  softDeleteCategoryQuestion(data){
    this.props.softDeleteCategoryQuestion(data);
  }

  addQuestion(){
    //this.props.gotoAddDemoQuestion(this.state.catID);
  }

  render() {

      let msg="";
      if(this.props.studyMessage){
        msg = this.props.studyMessage;
      }

      let catQuestionList = "";
    if(this.props.demoGraphicsCategoriesQuesListData && this.props.demoGraphicsCategoriesQuesListData.length > 0){
        let questions = this.props.demoGraphicsCategoriesQuesListData;
        catQuestionList = Object.keys(questions).map((item, index) => {
        let questionItem = questions[item];

        let checkIsSubQuestion = "";
        if(questionItem.sub_ques){
          checkIsSubQuestion = "Yes";
        }else{
          checkIsSubQuestion = "No";
        }

        return <tr key={index} >
            <td style ={{ textAlign : "center" }}>{index+1}</td>
            <td style ={{ textAlign : "center" }}>{this.state.categoryName}</td>
            <td>{questionItem.questions}</td>
            <td style ={{ textAlign : "center" }}>{questionItem.selectionType}</td>
            <td style ={{ textAlign : "center" }}>{questionItem.orderQues}</td>
            <td style ={{ textAlign : "center" }}>{checkIsSubQuestion}</td>
            <td className = "cat_action">
            <Link to={{
              pathname: '/editDemographicsQuestions',
              state: {
                editCategoryQuestionsItemData : questionItem
              }
              }}>
              < Icon icon={edit} size={30} style={{ color: '#336699' }}/>
            </Link>
            <button onClick = {this.softDeleteCategoryQuestion.bind(this, questionItem)} className = "removebutton">< Icon icon={androidDelete} size={30} style={{ color: '#EF233C' }}/></button>            
            </td>
          </tr>
          });
    }else{
      catQuestionList = "No data"
    }

    let showUploadImage ="";
    let checkShowUploadImage = "";
    if(this.state.catImage){
      checkShowUploadImage = <img src={apiConfig.imageUrl+this.state.catImage}  className="catImageView" />
    } 
    
    if(this.state.hideCategoryEdit){
      showUploadImage = 
        <div id="backgroundimagechoose"> <label >Background Image :</label>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
        {checkShowUploadImage}
        <br/><br/><br/><br/>
        </div>
    }else{
      showUploadImage = <div >
        <div id="backgroundimagechoose"> <label >Background Image :</label>
      <input type="file" id="choosefile" onChange={this._handleImageChange} value={this.state.value}/>
      </div><br/>
      <div style={{ color: "red", textAlign:"center", marginTop: "-15px" }} >{this.state.validationMsg.file}</div><br/></div>
    }

      return (
        <div className = "regPage">
            <div className = "createnewstudy">
            <div className = "studyheader"><h1> Edit Demographic's category</h1></div>
            <div className = "setbackbutton">
            <br/><button className = "editstudybackbtn"   onClick={this.categoryList.bind(this)}>Back</button><br/>
            <div className = "studypage">
            <label id = "lbl1">Category Name</label>
            <input type="text" className = "textFields" placeholder = "Category Name" name="categoryName" value={this.state.categoryName} onChange={this.onChange} disabled = {this.state.hideCategoryEdit} />
            <div style={{ color: "red", textAlign:"center", marginTop: "-15px" }} >{this.state.validationMsg.categoryName}</div><br/>

            {/* <label id = "lbl1">Category ID</label>
            <input type="text" className = "textFields" placeholder = "Category ID" name="catID" value={this.state.catID} onChange={this.onChange} />
            <div style={{ color: "red", textAlign:"center", marginTop: "-15px" }} >{this.state.validationMsg.catID}</div><br/> */}

            <label id = "lbl1">Order No</label>
            <input type="text" className = "textFields" placeholder = "Category Order" name="order_no" value={this.state.order_no} onChange={this.onChange} disabled = {this.state.hideCategoryEdit}/>
            <div style={{ color: "red", textAlign:"center", marginTop: "-15px" }} >{this.state.validationMsg.order_no}</div><br/><br/>
            <div>

            {showUploadImage}
            
            <div className = "stdbtn"><button  className="studySavebtn" onClick={this.saveData}  >{this.state.catActionButton}</button></div><br/>
            </div>
            <p className = "studyMSG">{msg}</p>
       </div>
       </div>

            <hr/>

        <div className = "catQuesListHeading"><h3>Demographics Question's List</h3></div>
        
        <Link to={{
              pathname: '/addDemoCatQues/&c:'+this.state.catID,
              state: {
                editCategoryItemData : this.props.editCategoryItem
              }
              }}><button  className = "createCouponbtn" onClick={this.addQuestion} >
        Add Question</button></Link>
        
        <div className = "autoscroll">
        <table className = "demoategoryTable">
          <thead>
            <tr >
              <th>Sr.No.</th>
              <th>Category ID</th>
              <th>Question</th>
              <th>Selection Type</th>
              <th>Order No.</th>
              <th>IsSubQuestion</th>
              <th>Action</th> 
            </tr>
          </thead>
            <tbody> 
              {catQuestionList}
            </tbody>
         </table>
        </div>

        </div>
        </div>
      );
    }
  }

export default EditDemoCategories;


// WEBPACK FOOTER //
// ./src/components/demographics/editDemoCategory.js